export default (theme) => ({
  root: {
    textDecoration: 'none',
    display: 'block',
    '& + $root': {
      borderTop: `1px solid ${theme.palette.layout.line.divider}`,
    },
  },
  content: {
    color: 'inherit',
  },
  listItemInner: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    textDecoration: 'none',
    padding: `${theme.spacing(2)} 0`,
    ':not(a[href]) > &:hover': {
      boxShadow: 'none',
    },
  },
  listItemInnerHover: {
    '&:hover': {
      background: theme.palette.background.alternative,
    },
    '& $informationContainer': {
      color: theme.palette.text.onMain,
    },
  },
  overlineLabel: {
    color: 'inherit',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
    },
  },
  sublineLabel: {
    color: 'inherit',
    marginBottom: theme.spacing(1),
  },
  title: {
    color: 'inherit',
    marginBottom: theme.spacing(1),
  },
  illustrationContainer: {
    flexShrink: 0,
    maxWidth: '270px',
    width: '40%',
    alignSelf: 'flex-start',
    position: 'relative',
  },
  informationContainer: {
    color: theme.palette.text.inactive,
    'a &': {
      color: theme.palette.text.onMain,
    },
    margin: `0 ${theme.spacing(4)}`,
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      margin: `0 ${theme.spacing(2)}`,
    },
  },
});
